import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import SidebarComponent from "../components/sidebar/sidebar.component";

const MainLayout: React.FC<any> = ({ children }: any) => {
  return (
    <Layout hasSider style={{ minHeight: "100vh" }}>
      <SidebarComponent />
      <Layout className="site-layout" style={{ marginLeft: 0 }}>
        <Content className="main-content-area">{children}</Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
